<template>
    <div class="header">
        <div class="headersorting">Sortering</div>
        <div class="start">
            <button class="start sortable" :class="activeSort(0)" v-on:click="sortNamn()"
                :aria-label="store.resultatSorteringsGrupper.grupp[0].label">
                {{ store.resultatSorteringsGrupper.grupp[0].namn }}
                <Svgicon iconName="pil-flytta"></Svgicon>
            </button>
        </div>
        <div class="end">
            <table>
                <tbody>
                    <tr>
                        <th class="label">{{ store.resultatSorteringsGrupper.grupp[1].namn }}
                        </th>
                        <td class="cell sortable">
                            <button class="start sortable" :class="activeSort(2)" v-on:click="showGrupp(2)"
                                :aria-label="store.resultatSorteringsGrupper.grupp[2].label">
                                {{ store.resultatSorteringsGrupper.grupp[2].namn }}
                                <Svgicon iconName="pil-flytta"></Svgicon>
                            </button>
                            <OnClickOutside @trigger="onClickOutsideHandler" v-if="showingGrupp(2)" class="sort"
                                style="display: block;">
                                <span class="sortText">{{ store.resultatSorteringsGrupper.grupp[2].label }}</span>
                                <ul>
                                    <li v-for="(soretering, index) in store.resultatSorteringsGrupper.grupp[2].soretering"
                                        :key="index">
                                        <label class="anstat-label" :for="soretering.namn">
                                            <input type="radio" :id="soretering.namn" name="sortering"
                                                v-on:click="sortGrupp(soretering.sortering)"
                                                :checked="soretering.sortering.sorteringskolumn === store.sort.sorteringskolumn &&
                                                    soretering.sortering.sorteringsordningdesc === store.sort.sorteringsordningdesc &&
                                                    soretering.sortering.sorteringsurvalsgrupp === store.sort.sorteringsurvalsgrupp">
                                            <span class="radiocheckmark"></span>
                                            <span>{{ soretering.namn }}</span>
                                        </label>
                                    </li>
                                </ul>
                            </OnClickOutside>
                        </td>
                        <td v-if="store.resultatSorteringsGrupper.grupp.length > 3" class="cell sortable">
                            <button class="start sortable" :class="activeSort(3)" v-on:click="showGrupp(3)"
                                :aria-label="store.resultatSorteringsGrupper.grupp[3].label">
                                {{ store.resultatSorteringsGrupper.grupp[3].namn }}
                                <Svgicon iconName="pil-flytta"></Svgicon>
                            </button>
                            <OnClickOutside v-if="showingGrupp(3)" class="sort" style="display: block;">
                                <span class="sortText">{{ store.resultatSorteringsGrupper.grupp[3].label }}</span>
                                <ul>
                                    <li v-for="(soretering, index) in store.resultatSorteringsGrupper.grupp[3].soretering"
                                        :key="index">
                                        <label class="anstat-label" :for="soretering.namn">
                                            <input type="radio" :id="soretering.namn" name="sortering"
                                                v-on:click="sortGrupp(soretering.sortering)"
                                                :checked="soretering.sortering.sorteringskolumn === store.sort.sorteringskolumn &&
                                                    soretering.sortering.sorteringsordningdesc === store.sort.sorteringsordningdesc &&
                                                    soretering.sortering.sorteringsurvalsgrupp === store.sort.sorteringsurvalsgrupp">
                                            <span class="radiocheckmark"></span>
                                            <span>{{ soretering.namn }}</span>
                                        </label>
                                    </li>
                                </ul>
                            </OnClickOutside>
                        </td>
                        <td v-if="store.resultatSorteringsGrupper.grupp.length > 4" class="cell sortable">
                            <button class="start sortable" :class="activeSort(4)" v-on:click="showGrupp(4)"
                                :aria-label="store.resultatSorteringsGrupper.grupp[4].label">
                                {{ store.resultatSorteringsGrupper.grupp[4].namn }}
                                <Svgicon iconName="pil-flytta"></Svgicon>
                            </button>
                            <OnClickOutside v-if="showingGrupp(4)" class="sort" style="display: block;">
                                <span class="sortText">{{ store.resultatSorteringsGrupper.grupp[4].label }}</span>
                                <ul>
                                    <li v-for="(soretering, index) in store.resultatSorteringsGrupper.grupp[4].soretering"
                                        :key="index">
                                        <label class="anstat-label" :for="soretering.namn">
                                            <input type="radio" :id="soretering.namn" name="sortering"
                                                v-on:click="sortGrupp(soretering.sortering)"
                                                :checked="soretering.sortering.sorteringskolumn === store.sort.sorteringskolumn &&
                                                    soretering.sortering.sorteringsordningdesc === store.sort.sorteringsordningdesc &&
                                                    soretering.sortering.sorteringsurvalsgrupp === store.sort.sorteringsurvalsgrupp">
                                            <span class="radiocheckmark"></span>
                                            <span>{{ soretering.namn }}</span>
                                        </label>
                                    </li>
                                </ul>
                            </OnClickOutside>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import useAstaStore from '../stores/AstaStore';
import Svgicon from '../components/svgicon.vue';
import { OnClickOutside } from '@vueuse/components';
import { AstaSortSettings } from '../../types/AstaTypes';

const store = useAstaStore();
const isshowingGrupp = ref(0);

function activeSort(index: number): string {
    let vy = store.display.vy;
    if (index === 0) {
        if (store.sort.sorteringskolumn === 'anmalningsalternativ') {
            return 'active';
        }
    } else if (index === 2) {
        if (vy === 'antagningspoang-urv1' || vy === 'antagningspoang-urv2') {
            if (store.sort.sorteringskolumn === 'lagstaantagnapoang') {
                return 'active';
            }
        } else if (vy === 'reserver-och-antagna-urv1' || vy === 'reserver-och-antagna-urv2') {
            if (store.sort.sorteringskolumn === 'antagna' || store.sort.sorteringskolumn === 'reserver') {
                return 'active';
            }
        } else if (vy === 'konsfordelning-urv1' || vy === 'konsfordelning-urv2') {
            if (store.sort.sorteringskolumn === 'manligaantagna' || store.sort.sorteringskolumn === 'kvinnligaantagna') {
                return 'active';
            }
        } else if (vy === 'aldersfordelning-urv1' || vy === 'aldersfordelning-urv2') {
            if (store.sort.sorteringskolumn === 'antagna24arelleryngre' ||
                store.sort.sorteringskolumn === 'antagna25till34ar' ||
                store.sort.sorteringskolumn === 'antagna35arelleraldre') {
                return 'active';
            }
        } else if (vy === 'sokande-sok') {
            if (store.sort.sorteringskolumn === 'forstahandsokande' || store.sort.sorteringskolumn === 'sokande') {
                return 'active';
            }
        } else if (vy === 'konsfordelning-sok') {
            if (store.sort.sorteringskolumn === 'manligasokande' || store.sort.sorteringskolumn === 'kvinnligasokande') {
                return 'active';
            }
        } else if (vy === 'aldersfordelning-sok') {
            if (store.sort.sorteringskolumn === 'sokande24arelleryngre'
                || store.sort.sorteringskolumn === 'sokande25till34ar'
                || store.sort.sorteringskolumn === 'sokande35arelleraldre') {
                return 'active';
            }
        }
    } else if (index === 3) {
        if (vy === 'antagningspoang-urv1' || vy === 'antagningspoang-urv2') {
            if (store.sort.sorteringskolumn === 'antagna') {
                return 'active';
            }
        } else if (vy === 'konsfordelning-urv1' || vy === 'konsfordelning-urv2') {
            if (store.sort.sorteringskolumn === 'manligareserver' || store.sort.sorteringskolumn === 'kvinnligareserver') {
                return 'active';
            }
        } else if (vy === 'aldersfordelning-urv1' || vy === 'aldersfordelning-urv2') {
            if (store.sort.sorteringskolumn === 'reserver24arelleryngre' ||
                store.sort.sorteringskolumn === 'reserver25till34ar' ||
                store.sort.sorteringskolumn === 'reserver35arelleraldre') {
                return 'active';
            }
        }
        return '';
    } else if (index === 4) {
        if ((vy === 'antagningspoang-urv1' || vy === 'antagningspoang-urv2') && store.sort.sorteringskolumn === 'reserver') {
            return 'active';
        }
    }
    return '';
}
function showGrupp(index: number) {
    isshowingGrupp.value = isshowingGrupp.value === index ? 0 : index;
}
function showingGrupp(index: number): boolean {
    return isshowingGrupp.value === index;
}
function onClickOutsideHandler() {
    isshowingGrupp.value = 0;
}
function sortNamn() {
    if (store.sort.sorteringskolumn === 'anmalningsalternativ') {
        store.setSort({
            sorteringskolumn: 'anmalningsalternativ',
            sorteringsordningdesc: !store.sort.sorteringsordningdesc,
            sorteringsurvalsgrupp: null,
        });
    } else {
        store.setSort({
            sorteringskolumn: 'anmalningsalternativ',
            sorteringsordningdesc: false,
            sorteringsurvalsgrupp: null,
        });
    }
}
function sortGrupp(soretering: AstaSortSettings) {
    store.setSort(soretering);
    isshowingGrupp.value = 0;
}
</script>